module.exports = __webpack_public_path__ + "assets/img/zy3.eebebe13.png";